import { render, staticRenderFns } from "./ManageProductModal.vue?vue&type=template&id=06010e52&scoped=true&"
import script from "./ManageProductModal.vue?vue&type=script&lang=js&"
export * from "./ManageProductModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageProductModal.vue?vue&type=style&index=0&id=06010e52&prod&lang=css&"
import style1 from "./ManageProductModal.vue?vue&type=style&index=1&id=06010e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06010e52",
  null
  
)

export default component.exports